/*
 * AZP-7076 — folds the collection's SEO copy behind a "Read more" button
 * (Figma 4482:5262).
 *
 * The copy is a merchant-edited metafield, so how tall it runs is only known once it is
 * laid out. The element measures it and takes its own button away when the copy already
 * fits — a "Read more" that reveals nothing is worse than no button at all.
 *
 * The collapsed height is the CSS custom property `--seo-read-more-height`, so the two
 * viewports stay a stylesheet concern.
 */
(function () {
  "use strict";

  if (customElements.get("seo-read-more")) return;

  customElements.define(
    "seo-read-more",
    class SeoReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector("[data-seo-read-more-content]");
        this.toggle = this.querySelector("[data-seo-read-more-toggle]");
        if (!this.content || !this.toggle) return;

        this.onResize = this.debounce(this.measure.bind(this), 150);
        this.toggle.addEventListener("click", this.onClick.bind(this));
        window.addEventListener("resize", this.onResize);

        this.measure();

        // Images and web fonts land after the first measurement and change the height.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.measure.bind(this));
        }
        window.addEventListener("load", this.measure.bind(this), { once: true });
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.onResize);
      }

      collapsedHeight() {
        var value = window
          .getComputedStyle(this)
          .getPropertyValue("--seo-read-more-height");
        return parseFloat(value) || 0;
      }

      measure() {
        if (this.expanded) return;

        var limit = this.collapsedHeight();
        var needsToggle = limit > 0 && this.content.scrollHeight > limit + 8;

        this.classList.toggle("is-collapsible", needsToggle);
        this.toggle.hidden = !needsToggle;
      }

      onClick() {
        this.expanded = !this.classList.contains("is-expanded");
        this.classList.toggle("is-expanded", this.expanded);
        this.toggle.textContent = this.expanded
          ? this.toggle.dataset.readLess
          : this.toggle.dataset.readMore;

        if (!this.expanded) {
          this.scrollIntoView({ block: "start", behavior: "smooth" });
          this.measure();
        }
      }

      debounce(fn, wait) {
        var timer;
        return function () {
          window.clearTimeout(timer);
          timer = window.setTimeout(fn, wait);
        };
      }
    }
  );
})();
